import { Link } from 'react-router-dom';
import { ShieldX, Home } from 'lucide-react';
import type { AccessDeniedReason } from '@/services';

const reasonContent: Record<AccessDeniedReason, { title: string; description: string }> = {
  NO_MODULE_ACCESS: {
    title: 'Module Not Available',
    description: "You don't have access to this module. Contact your administrator to request access.",
  },
  FEATURE_NOT_LICENSED: {
    title: 'Feature Not Available',
    description: "This feature is not included in your company's current plan.",
  },
  FEATURE_NOT_ENABLED: {
    title: 'Feature Disabled',
    description: 'This feature is currently disabled for your organization.',
  },
  NO_PERMISSION: {
    title: 'Permission Required',
    description: "You don't have permission to access this page. Contact your administrator.",
  },
};

interface AccessDeniedProps {
  reason: AccessDeniedReason;
}

export function AccessDenied({ reason }: AccessDeniedProps) {
  const { title, description } = reasonContent[reason];

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="text-center animate-fade-in">
        <div className="w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-6">
          <ShieldX className="w-10 h-10 text-destructive" />
        </div>
        <h1 className="text-3xl font-bold text-foreground mb-3">{title}</h1>
        <p className="text-muted-foreground mb-8 max-w-md mx-auto">{description}</p>
        <Link to="/dashboard" className="btn-primary inline-flex items-center gap-2">
          <Home className="w-5 h-5" />
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
